export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./warn-transactions.vue?vue&type=template&id=5b1b9dd0&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/warn-transactions.vue?vue&type=template&id=5b1b9dd0&scoped=true
// module id = THD3
// module chunks = 0